import type { IntlShape } from 'react-intl';

/** Reset timestamps represent calendar dates in UTC, regardless of the viewer's time zone. */
export const formatResetDate = (intl: IntlShape, resetDate?: number): string | undefined => {
	if (
		resetDate === undefined ||
		!Number.isFinite(resetDate) ||
		resetDate <= 0 ||
		Number.isNaN(new Date(resetDate).getTime())
	) {
		return undefined;
	}
	return intl.formatDate(resetDate, { month: 'short', day: 'numeric', timeZone: 'UTC' });
};
